"use strict";

angular.module("internal.exams").controller("InternalExamViewsDetails", [
    "$scope",
    "$stateParams",
    function ($scope, $stateParams) {
        $scope.saveMessage = $stateParams.saveMessage;
    }]);